/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Pending_CheckInputs */

const vi_einvoice_pending_check = /** @type {(inputs: Einvoice_Pending_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiểm tra lại với MISA`)
};

/**

* @param {Einvoice_Pending_CheckInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_pending_check = /** @type {((inputs?: Einvoice_Pending_CheckInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Pending_CheckInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_pending_check(inputs)
});